export default "__VITE_ASSET__Dw612kzP__"